'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _hexToRGB = require('./hexToRGB');

var _hexToRGB2 = _interopRequireDefault(_hexToRGB);

var _rgbToHex = require('./rgbToHex');

var _rgbToHex2 = _interopRequireDefault(_rgbToHex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getColor(hex, opacity) {
    if (!opacity) {
        if (opacity !== 0) {
            opacity = 1;
        }
    }
    var rgb = (0, _hexToRGB2.default)(hex);
    rgb = rgb.substr(4).split(')')[0].split(',');
    rgb[0] = 255 - opacity * (255 - rgb[0]);
    rgb[1] = 255 - opacity * (255 - rgb[1]);
    rgb[2] = 255 - opacity * (255 - rgb[2]);
    rgb = 'rgb(' + Math.round(rgb[0]) + ',' + Math.round(rgb[1]) + ',' + Math.round(rgb[2]) + ')';
    hex = (0, _rgbToHex2.default)(rgb);
    return hex;
}

exports.default = getColor;